import { render, staticRenderFns } from "./KidsAuditLogs.vue?vue&type=template&id=2ee7dc30&scoped=true&"
import script from "./KidsAuditLogs.vue?vue&type=script&lang=js&"
export * from "./KidsAuditLogs.vue?vue&type=script&lang=js&"
import style0 from "./KidsAuditLogs.vue?vue&type=style&index=0&id=2ee7dc30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee7dc30",
  null
  
)

export default component.exports